<template>
    <div>
        <div v-if="toastList.length>0" class="bgc">
            <div style="padding:20px 10px ;" >
                评价 <van-rate v-model="this.DetailedData.commentStar" readonly  /> <span>{{Eaction}}</span>
            </div>
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh" class="bgc"> <!-- 下拉刷新 -->
                <van-list v-model="loading" :finished="finished" loading-text="正在加载中..." :error.sync="error" error-text="请求失败，点击重新加载" finished-text="我是有底线的哦 ~ " @load="onLoad"><!-- 上拉加载 -->
                    <div style="border-top:0.5px solid #ccc;" v-for="(item,index) in toastList" :key="index">
                        <div style="width:96%; margin:0 auto;">
                            <dl class="VantDl">
                                <dt style="float:left;"><van-image class="Vanimage"  :src="item.memberIcon">
                                  <template v-slot:error><img src="@/assets/borderImg.png" alt=""></template>
                                  </van-image>
                                </dt>
                                <dd class="VanDD">
                                  <p v-if="item.memberNickName">{{parseStringToStar(item.memberNickName)}}</p>
                                  <p v-else class="p">****</p>
                                  <van-rate v-model="item.star" readonly  />
                                </dd>
                            </dl>
                            <div class="marginL">
                                <div style="color:#999999;margin-top:3px;">{{item.createTime}} <span style="padding-left:10px;">{{item.productAttribute}}</span></div>
                                <div style="margin:8px 0px;line-height:20px;">{{item.content}}</div>
                                <div v-if="item.pics!=''" style="display:flex;justify-content: flex-start;" >
                                    <div v-for="(ele,i) in picArr(item.pics)" :key="i" style="margin-right:10px;">
                                        <van-image class="VanimageS" :src="ele" v-if="ele!=''" @click="ImageClick(item.pics,i)">
                                          <template v-slot:error><img src="@/assets/placeholder.png" alt=""></template>
                                        </van-image>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </van-list>
            </van-pull-refresh>
        </div>
        <div v-else style="margin:80px auto;text-align: center;color:#ccc;font-size:14px;" class="bgc">
            目前暂无评价，欢迎你来坐第一个沙发哦 ~
        </div>
    </div>
</template>
<script>
import { Image, List, PullRefresh, Rate, Cell, ImagePreview } from 'vant'
import { productInfo, comment } from '../../request/api.js'
export default {
  components: {
    [Cell.name]: Cell,
    [Rate.name]: Rate,
    [Image.name]: Image,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [ImagePreview.name]: ImagePreview
  },
  data () {
    return {
      error: false,
      toastList: [], // 请求数据
      loading: false, // 上拉加载
      finished: false, // 上拉加载完毕
      isLoading: false, // 下拉刷新
      pageNum: 1, // 页码
      UserEvaluation: '',
      Eaction: '',
      DetailedData: [],
      forImgUrl: [],
      str: 5
    }
  },
  methods: {
    onLoad () {
      this.pageNum += 1
      const params = {
        pageSize: 10,
        pageNum: this.pageNum,
        id: this.$route.params.id
      }
      console.log(params)
      comment(params).then(res => {
        if (res.code === 200) {
          setTimeout(() => {
            this.toastList = this.toastList.concat(res.data.list)
            this.loading = false
            if (this.toastList.length >= res.data.total) {
              this.finished = true
              console.log('到底了')
            }
          }, 1000)
        } else {
          this.error = true
        }
      }).catch(res => {
        console.log(res)
      })
    },
    parseStringToStar (str) {
      console.log(str)
      return str.length > 1 ? str.substr(0, 1) + new Array(str.length - 1).join('*') + str.substr(-1) : str
    },
    onRefresh () {
      setTimeout(() => {
        console.log('下拉刷新')
        // 清空列表数据
        this.finished = false
        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.isLoading = false
        this.onLoad()
      }, 1000)
    },
    picArr (pics) {
      return pics.split(',')
    },
    ImageClick(item, index) {
      document.documentElement.scrollTop = this.scrollTop
      console.log(item, index)
      var itemLength = item.split(',')
      console.log(itemLength[itemLength.length - 1])
      if (itemLength[itemLength.length - 1] === '') {
        itemLength.splice(itemLength.length - 1, 1)
      }
      ImagePreview({
        images: itemLength,
        closeOnPopstate: true,
        startPosition: index
      })
    }
  },
  created () {
    document.documentElement.scrollTop = 0
    productInfo(this.$route.params.id).then(res => {
      console.log(res)
      this.DetailedData = res.data
      return this.DetailedData
    }).then(res => {
      console.log(res)
      const params = {
        pageSize: 10,
        pageNum: 1,
        id: this.$route.params.id
      }
      comment(params).then(res => {
        console.log(res)
        this.UserEvaluation = '用户评论' + '(' + this.DetailedData.comment + ')'
        this.Eaction = this.DetailedData.commentRate + '%  ' + '好评'
        this.toastList = res.data.list
      }).catch(res => {
        console.log(res)
      })
    }).catch(res => {
      console.log(res)
    })
  }
}
</script>
<style lang="less" scoped>
.bgc{
  min-height: 100vh;
}
    .VantDl {
      height: 64px;
      margin: 12px 0;
    }
    .Vanimage {
      width: 64px !important;
      height: 64px !important;
      /deep/.van-image__error{
        width: 64px;
          height: 64px;
        img{
            width: 100%;
            height: 100%;
          }
      }
    }
    .VanimageS {
        width: 150px;
        height: 150px;
        /deep/.van-image__error{
        width: 150px;
          height: 150px;
        img{
            width: 100%;
            height: 100%;
          }
      }
    }
    .VanDD {
      height: 64px;
      display: flex;
      align-items: center;
      margin-left: 80px;
      p{
        font-size: 26px;
        margin-right: 20px;
      }
      .p{
        padding-top: 10px;
      }
    }
</style>
